import { ActionIcon, Menu, Button } from "@mantine/core";
import { IChecklistItemRow } from "@mctypes/checklist.types";
import { useState } from "react";
import CreateItemWithBoardSelectorModal from "../../../components/CreateItemWithBoardSelectorModal/CreateItemWithBoardSelectorModal";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { MCApplicationsUrlEnum } from "../../../mc-shared/sharedConstants";
import ConnectExistingIssueToItemModalWrapper from "../../ConnectExistingIssueToItemModalWrapper";
import { useGetIssueBoardsQuery } from "../issuesApp/IssueBoardRTK";
import { connectOrDisconnectIssueFromChecklistItemThunk, createIssueOnChecklistItemThunk } from "./checklistSlice";
import { IconPlus } from "@tabler/icons-react";

const ChecklistConnectIssue: React.FC<{ checklistRow: IChecklistItemRow; projectId: string }> = ({
  checklistRow,
  projectId,
}) => {
  const dispatch = useAppDispatch();
  const apps = useAppSelector((state) => state.globalReducer.apps);

  const { data: issueBoards = [] } = useGetIssueBoardsQuery({
    projectId: projectId,
  });

  const [newIssueModalOpen, setNewIssueModalOpen] = useState<boolean>(false);
  const [connectExistingModalOpen, setConnectExistingModalOpen] = useState<boolean>(false);

  const onCreateIssue = (boardId: string) => {
    dispatch(createIssueOnChecklistItemThunk(boardId, checklistRow._id));
    setNewIssueModalOpen(false);
  };

  const onConnect = (issueId: string) => {
    dispatch(connectOrDisconnectIssueFromChecklistItemThunk(checklistRow._id, issueId, "CONNECT"));
    setConnectExistingModalOpen(false);
  };

  return (
    <>
      <ConnectExistingIssueToItemModalWrapper
        opened={connectExistingModalOpen}
        onConnected={(boardId, issueId) => onConnect(issueId)}
        projectId={projectId}
        closeModal={() => setConnectExistingModalOpen(false)}
        blockedIssueIds={(checklistRow.connectedIssues || []).map((issue) => issue._id)}
      />
      <CreateItemWithBoardSelectorModal
        boards={(issueBoards || []).map((board) => {
          return {
            project: board.project,
            name: board.name,
            _id: board._id,
            status: board.status,
          };
        })}
        onCreate={onCreateIssue}
        modalTitle="Koble sak til sjekklistepunkt"
        opened={newIssueModalOpen}
        onClose={() => setNewIssueModalOpen(false)}
        currentApp={MCApplicationsUrlEnum.ISSUE}
        apps={apps}
        projectId={projectId}
        createButtonText="Opprett sak"
      />
      <Menu position="bottom-start" withinPortal={false} shadow="md">
        <Menu.Target>
          <Button
            color="green"
            variant="subtle"
            size="compact-sm"
            onMouseDown={(event) => event.stopPropagation()}
            onClick={(event) => event.stopPropagation()}
          >
            <IconPlus stroke={4} size={16} />
          </Button>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item onClick={() => setNewIssueModalOpen(true)}>Ny</Menu.Item>
          <Menu.Item onClick={() => setConnectExistingModalOpen(true)}>Koble eksisterende</Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </>
  );
};

export default ChecklistConnectIssue;
